import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IPrivilegeUsersModal, IAuthReduxProps, ITarget } from '../../types/interfaces';
import { getUsersByPrivilegePromise } from '../../flux/actions/userActions';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt, faUser } from '@fortawesome/free-solid-svg-icons'
import { E_ERROR } from '../../types/errors';
import { useHistory } from 'react-router-dom';
import { useAlert } from "react-alert";
import Loading from '../Loading';

const PrivilegeUsersModal = ({
  modal,
  setModal,
  modalData,
  auth
 }: IPrivilegeUsersModal) => {
  const history = useHistory();
  const alert = useAlert();
  const [usersListP, setUsersListP] = useState<any[]>([]);
  const [usersListPLoading, setUsersListPLoading] = useState(false);
  const [usersPSearch, setUsersPSearch] = useState('');

  const handleToggle = () => setModal(!modal);
  
  const usersPSearchChangeHandler = (e: ITarget) => setUsersPSearch(e.target.value);

  const modalOpenedHandle = () => {
    setUsersListP([])
    if(modalData?.id){
      setUsersListPLoading(true)
      getUsersByPrivilegePromise(modalData.id)
      .then(e => setUsersListP(e))
      .finally(() => setUsersListPLoading(false))
    }
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle}>
        <ModalHeader toggle={handleToggle}>Liste des utilisateurs ayant le droit "<b>{modalData?.label || "-"}</b>"</ModalHeader>
        <ModalBody>
          <Container className="linesConfirmationContainer">
            <Row className="mb-2">
              <Col xs="12">
                <Input placeholder="Recherche..." value={usersPSearch} onChange={usersPSearchChangeHandler} />
              </Col>
            </Row>
            {usersListPLoading ? <Loading size={90} /> : <Row>
              {usersListP.filter(e => !usersPSearch || (e.username?.toLowerCase().includes(usersPSearch.toLowerCase()))).map((e, key) => <Col xs="12" sm="4" key={key}>
                <div style={{boxShadow: "0px 1px 30px rgba(34, 35, 58, 0.1)", borderRadius: "8px", padding: "5px 10px", marginBottom: "5px"}}>
                <FontAwesomeIcon icon={faUser} />&nbsp;{e.username || "-"}&nbsp;<FontAwesomeIcon icon={faExternalLinkAlt} style={{cursor: "pointer"}} onClick={t => {
                  if(e.id !== null && e.id !== undefined){
                    if (t.ctrlKey){
                      window.open('/gestion_utilisateur/' + e.id,'_blank');
                      return;
                    }
                    setModal(false)
                    history.push({ pathname: `/gestion_utilisateur/${e.id}` })
                  }
                  else
                    alert.error(E_ERROR.NO_USER_WITH_THIS_ID)
                }} />
              </div>
              </Col>)}
            </Row>}
          </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, { })(PrivilegeUsersModal);
